import React from 'react';
import styled from 'styled-components';
import {InnerLayout} from '../styles/Layouts';
import Title from '../Components/Title';
import ServiceCard from '../Components/ServiceCard';
import design from '../img/abc.png';
import intelligence from '../img/abc.png';
import gamedev from '../img/abc.png';

function ServicesSection() {
    return (
        <InnerLayout>
            <ServicesSectionStyled>
                <Title title={' Performance STATE'}  />
                <div className="services">
                    <ServiceCard 
                        image={design} 
                        title={'HackerRank'} 
                        paragraph={'5 stars in Hackerrank'}
                    />
                    <div className="mid-card">
                        <ServiceCard 
                            image={intelligence} 
                            title={'LeetCode'} 
                            paragraph={'4 stars on codechef '}
                        />
                    </div>
                   { <ServiceCard 
                        image={gamedev} 
                        title={'Codeforces'} 
                        paragraph={'4 stars on codechef'}
                    />}
                </div>
            </ServicesSectionStyled>
        </InnerLayout>
    )
}

const ServicesSectionStyled = styled.section`
    .services{
        margin-top: 5rem;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 1.5rem;
        @media screen and (max-width:1000px){
            flex-direction: column;
        }
        @media screen and (max-width:950px){
            grid-template-columns: repeat(2, 1fr);
        }
        @media screen and (max-width:650px){
            grid-template-columns: repeat(1, 1fr);
        }
       
    }
`;

export default ServicesSection;
